const familyRegActions = {
  SET_ADMIN_SETTINGS: "SET_ADMIN_SETTINGS",
  /**
   * Spread the api payload from getAdminSettings onto the root of state.
   * @param {object} adminSettings
   */
  setAdminSettings: (adminSettings) => ({
    type: familyRegActions.SET_ADMIN_SETTINGS,
    adminSettings,
  }),
};

export default familyRegActions;
